import { ChangeDetectionStrategy, Component, inject, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { ComponentStatus } from '../state/state.component';
import { UserApiService } from '../../apis/user/user-api.service';
import { IInitDataModel } from '../../apis/user/model/user.model';
import { AppStateService } from '../../services/app-state.service';
import { Router, RouterOutlet } from '@angular/router';
import { NotificationService } from '../../services/notification.service';
import { LoadingContainerComponent } from '../loading-container/loading-container.component';
import { AppBarComponent } from './app-bar/app-bar.component';
import { UserType } from '@oogaday/shared';
import { isPlatformBrowser } from '@angular/common';
import { BaseComponent } from '../state/base.component';

@Component({
  selector: 'oo-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LoadingContainerComponent,
    AppBarComponent,
    RouterOutlet,
  ],
})
export class MainComponent extends BaseComponent implements OnInit {
  readonly router = inject(Router);
  private readonly appStateService = inject(AppStateService);
  private readonly userApi = inject(UserApiService);
  private readonly notificationService = inject(NotificationService);
  private readonly platformId = inject<Object>(PLATFORM_ID);

  readonly status = signal<ComponentStatus>('loading');
  readonly initData = signal<IInitDataModel | null>(null);
  readonly isSupperAdmin = signal(false);

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.fetchData();
      this.initListeners();
    }
  }

  logout(): void {
    this.userApi.logout()
      .then(() => {
        this.router.navigate(['/landing/login']);
      })
      .catch((e: Error) => {
        console.error(e);
        this.notificationService.notifyError();
      });
  }

  private fetchData(): void {
    this.status.set('loading');
    this.userApi.getInitData()
      .then((initData) => {
        this.appStateService.setAppData(initData);
        this.status.set('ready');
        this.initData.set(initData);
        this.isSupperAdmin.set(initData.user.type === UserType.SUPER_ADMIN);
      })
      .catch((e: Error) => {
        console.error(e);
        this.status.set('error');
      });
  }

  private initListeners(): void {
    this.addSubscription(this.appStateService.initDataChange.subscribe((initData) => {
      this.initData.set(initData);
    }));
  }
}
